function getEnv(key) {
    return window?.__ENV__?.[key] ?? process.env?.[key] ?? undefined;
}

export const ENV = {
    BACK_URI: getEnv("REACT_APP_BACK_URI"),
    TTS: getEnv("REACT_APP_TTS"),
};